import { validate as validateUuid } from 'uuid'
import { ICrossServiceContext } from './CrossServiceContextPropagator'

const isUuid = (maybeUuid: unknown): boolean => {
  if (typeof maybeUuid === 'string') {
    return validateUuid(maybeUuid)
  }
  if (maybeUuid instanceof String) {
    return validateUuid(maybeUuid.toString())
  }
  return false
}

const isString = (maybeString: unknown): boolean => typeof maybeString === 'string' || maybeString instanceof String

export const isCrossServiceContext = (context: unknown): context is ICrossServiceContext =>
  context !== null &&
  typeof context === 'object' &&
  'correlationId' in context &&
  isUuid(context.correlationId) &&
  'spanId' in context &&
  isUuid(context.spanId) &&
  'rootSpanLabel' in context &&
  isString(context.rootSpanLabel) &&
  context.rootSpanLabel !== ''
